import { render, staticRenderFns } from "./TraceSourceMarker.vue?vue&type=template&id=3b12a808&scoped=true&"
import script from "./TraceSourceMarker.vue?vue&type=script&lang=js&"
export * from "./TraceSourceMarker.vue?vue&type=script&lang=js&"
import style0 from "./TraceSourceMarker.vue?vue&type=style&index=0&id=3b12a808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b12a808",
  null
  
)

export default component.exports